<template lang="pug">
.time-off-balance-no-data.mt-20.text-center
  img(
    :src="IMAGE_NO_REPORT_DATA"
    alt="No time off balances"
    height="300"
  )
  h4.title {{ errorMessage }}
  h5.text-superlight {{ helpText }}
</template>

<script>
import { IMAGE_NO_REPORT_DATA } from '~/rails_assets';

export default {
  props: {
    hasFilters: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IMAGE_NO_REPORT_DATA,
    };
  },
  computed: {
    errorMessage() {
      if (this.hasFilters) {
        return 'Nothing matches the current filters';
      }

      return 'No time off balances to show';
    },
    helpText() {
      if (this.hasFilters) {
        return 'Try changing or removing some filters to see something.';
      }

      return 'Expecting to see something? Try adding members to your policies first.';
    },
  },
};
</script>
